import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Videoproduction() {
  return (
    <section className="video_production p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={8}
            lg={7}
            xl={7}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>
              SaaS Video Production to <span>Deliver Value for Everyone</span>
            </h2>
            <p>
              Our SaaS video team has grown by leaps and bounds, and there’s one
              reason to it. We’ve created outstanding SaaS product videos for a
              product hailing from literally every industry.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="video_valuee_main">
              <div className="value_item_video">
                <Link to="https://www.tekrevol.com/healthcare-app-development">
                  <p>Healthcare</p>
                </Link>
              </div>
              <div className="value_item_video">
                <p>Education</p>
              </div>
              <div className="value_item_video">
                <p>Real Estate</p>
              </div>
              <div className="value_item_video">
                <p>Cybersecurity</p>
              </div>
              <div className="value_item_video">
                <p>Beauty</p>
              </div>
              <div className="value_item_video">
                <p>E-commarce</p>
              </div>
              <div className="value_item_video">
                <p>Fintech</p>
              </div>
              <div className="value_item_video">
                <p>Retail</p>
              </div>
              <div className="value_item_video">
                <p>Music</p>
              </div>
              <div className="value_item_video">
                <p>On-Demand</p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Videoproduction;
